import { SET_FINDER_TYPE_ID } from './actionTypes';

export function setFinderTypeId(finderTypeId) {
    return { type: SET_FINDER_TYPE_ID, finderTypeId };
}